/**
 * electric auth whoami
 *
 * Display current auth context.
 */

import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printKeyValue } from '../../output.js'

export const whoamiCommand = new Command(`whoami`)
  .description(`Show the currently authenticated user`)
  .action(async () => {
    const json = whoamiCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.auth.whoami({})

      if (isQuiet()) {
        printQuiet(result.type === `user` ? result.userId : result.tokenId)
        return
      }

      if (json) {
        printJson(result)
      } else if (result.type === `user`) {
        printKeyValue([
          [`Type:`, `User`],
          [`User ID:`, result.userId],
          [`Email:`, result.email],
        ])
      } else {
        printKeyValue([
          [`Type:`, `API Token`],
          [`Token ID:`, result.tokenId],
          [`Workspace:`, result.workspaceId],
          [`Scopes:`, result.scopes.join(`, `)],
        ])
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
